module.exports = __webpack_public_path__ + "assets/img/btn-detail-d211faea.png";